import {Button,Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import useDBO from "../../../hooks/useDBO";
import Loading from "../../../Loading";
import Error from "../../../components/Error";
import mut from "../../../hooks/mut";
import { useState } from "react";




export default function SwapLessons(props) {
    const { open, setOpen, lesson, refresh } = props;
    const lessons = useDBO(`/get-next-lessons/${lesson._id}`)
   
    if (lessons.loading) return <Loading />
    if (lessons.error) return <Error message="Couldn't load lessons for this class" />


  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>Swap lessons</DialogTitle>
          <DialogContent>
              {lessons.filter(l => l.tDate !== lesson.tDate).map(l => <DrawLessonOrTest key={lesson._id} lesson={l} oldLessonId={lesson._id} refresh={refresh} setOpen={setOpen} />)}
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={() => setOpen(false)}>Close</Button>

      </DialogActions>
    </Dialog>
  );
}

function DrawLessonOrTest({ lesson, oldLessonId, refresh, setOpen }) {
     const [disabled, setDisabled] = useState(false);
  
    const handleClick = async () => {
        if(disabled) return
        setDisabled(true);
        let res = await mut("post", `/swap-lessons/${oldLessonId}`, { lessonToSwapWith: lesson._id })
        if (res.success) {
            refresh()
            setOpen(false);
            setDisabled(false)
        }
        if(res.error) setDisabled(false)
    }
    return (
      <div className="p-2 border-1 mb-2 border-gray-300 rounded hover:bg-gray-100 cursor-pointer" onClick={handleClick}>
        <div className="font-bold text-sm">
          {new Date(lesson.tDate).fDate()}
        </div>
        {lesson.lessonOrTest && lesson.lessonOrTest.type === "lesson" && (
          <DrawLesson lesson={lesson.lessonOrTest.lesson} />
        )}
        {lesson.lessonOrTest && lesson.lessonOrTest.type === "test" && (
          <DrawTest test={lesson.lessonOrTest} />
        )}
      </div>
    );
}

function DrawLesson({ lesson }) {

    return (
      <div >
        <div>
          Unit {lesson.unit.unitNumber}: {lesson.unit.name}
        </div>
        <div>
          Lesson {lesson.lessonNumber}: {lesson.name}
        </div>
      </div>
    );
}

function DrawTest({ test }) {
  console.log(test.unit)
  return (
    <div>
    Unit {test.unit.unitNumber} test
    </div>
  );
}